import { useEffect, useLayoutEffect } from 'react';
export function getUseIsomorphicLayoutEffect(ssr) {
  // If we have an explicit ssr value, use that to determine if we 
  // are server or client-side.
  if (typeof ssr === 'boolean') {
    return ssr ? useEffect : useLayoutEffect;
  } // Otherwise, try to detect SSR state using the existence of the DOM.
  // This check is not foolproof as some SSR solutions still use a DOM
  // to perform server-side rendering.


  return typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? useLayoutEffect : useEffect;
}